
import { mapGetters, mapState } from 'vuex'
import markerSDK from '@marker.io/browser'
import Global from '@/mixins/Global'

export default {
  mixins: [Global],
  computed: {
    ...mapState('lookups', ['pastoralMapping']),
    ...mapGetters('profile', ['pastoralRoleId', 'isLeader']),
  },
  watch: {
    pastoralMapping (pastoralMapping) {
      if (this.pastoralRoleId || this.isLeader) {
        const isLdr = pastoralMapping[this.pastoralRoleId] >= 6 || this.isLeader
        this.$store.dispatch('profile/updateIsLeader', isLdr)
        this.$store.dispatch('calendar/updateIsLeadersCalendar', isLdr)
      }
    },
    pastoralRoleId (pastoralRoleId) {
      if (this.pastoralMapping || this.isLeader) {
        const isLdr = this.pastoralMapping[pastoralRoleId] >= 6 || this.isLeader
        this.$store.dispatch('profile/updateIsLeader', isLdr)
        this.$store.dispatch('calendar/updateIsLeadersCalendar', isLdr)
      }
    },
  },
  mounted () {
    this.updateBodyBackground(this.$route.path)
  },
  methods: {
    updateBodyBackground (path) {
      if (path.includes('/announcement')) {
        document.body.style.backgroundColor = '#E5E2DF'
      } else {
        document.body.style.backgroundColor = ''
      }
    },
  },
  async created () {
    await Promise.all([
      this.$store.dispatch('profile/fetchProfile'),
      this.$store.dispatch('lookups/fetchIfNotYet'),
    ])
    if (process.env.NODE_ENV === 'staging') {
      const widget = await markerSDK.loadWidget({
        destination: process.env.MARKERIO_DESTINATION, // <- Your unique destination ID
      })
      widget.setReporter({ email: this.email, fullName: this.name })
    }
  },
}
